import InfoSignatureStep0FormComponent from '../../components/info-signature/InfoSignatureStep0FormComponent';

export default function InfoSignatureStep0Bloc() {

      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Vos documents précontractuels</h2>
            <p className="text m-y-sm">Afin d'accéder à la signature éléctronique de votre contrat, merci de bien vouloir prendre connaissance et accepter les documents suivants</p>
            <InfoSignatureStep0FormComponent/>
          </div>
        </div>
      )
}